var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 8,
    viewBox: "0 0 8 8",
    width: 8,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 0 .23901 2.49095.99706-2.295176-.54243 2.442886 1.6575-1.874728-1.27078 2.155708 2.15571-1.27078-1.87473 1.6575 2.44289-.54243-2.29518.99706 2.49095.23901-2.49095.23901 2.29518.99706-2.44289-.54243 1.87473 1.6575-2.15571-1.27078 1.27078 2.15571-1.6575-1.87473.54243 2.44289-.99706-2.29518-.23901 2.49095-.23901-2.49095-.99706 2.29518.54243-2.44289-1.6575 1.87473 1.27078-2.15571-2.155708 1.27078 1.874728-1.6575-2.442886.54243 2.295176-.99706-2.49095-.23901 2.49095-.23901-2.295176-.99706 2.442886.54243-1.874728-1.6575 2.155708 1.27078-1.27078-2.155708 1.6575 1.874728-.54243-2.442886.99706 2.295176z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.78954a23cb396c3ad4c9a4e069e97381.svg";
export { ForwardRef as ReactComponent };